var script = {
  inject: ['$table'],
  inheritAttrs: false,
  props: {
    row: {
      type: Object,
      default: null
    }
  },
  computed: {
    expanded() {
      if (this.row) {
        return Boolean(this.$table.treeExpandedMap[this.row[this.$table.rowKey]]);
      }
      return this.$table.isAllTreeExpanded;
    }
  },
  methods: {
    handleExpand() {
      if (this.row) {
        this.$table.toggleRowTreeExpand(this.row);
      } else {
        this.$table.toggleAllRowsTreeExpand();
      }
    }
  }
};

export { script as default };
//# sourceMappingURL=tree.vue2.js.map
